import { Injectable, inject } from '@angular/core';

import { Odds as OddsBpos, OddsFormat } from '@bpos';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { UserOddsFormatSettingsService } from '@frontend/sports/user/feature';

import { Odds } from './odds';

@Injectable({ providedIn: 'root' })
export class BposOddsConverterService {
    private readonly userOddsFormatSettingsService = inject(UserOddsFormatSettingsService);

    convertToBposOdds(odds: Odds): OddsBpos {
        const oddsFormat = this.userOddsFormatSettingsService.oddsFormat;
        const oddsInAllFormat = <OddsBpos>{
            oddsFormat: this.getBposOddsFormat(),
        };

        switch (oddsFormat) {
            case OddsDisplayFormat.UK:
                oddsInAllFormat.british = odds.fractional;
                break;
            case OddsDisplayFormat.US:
                oddsInAllFormat.american = odds.moneyline;
                break;
            default:
                oddsInAllFormat.european = odds.decimals;
        }

        return oddsInAllFormat;
    }

    private getBposOddsFormat(): OddsFormat {
        switch (this.userOddsFormatSettingsService.oddsFormat) {
            case OddsDisplayFormat.UK:
                return OddsFormat.British;
            case OddsDisplayFormat.US:
                return OddsFormat.American;
            default:
                return OddsFormat.European;
        }
    }
}
